import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useAuth } from "../Auth/AuthPage.jsx";

const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

const SpecialButton = ({ event, onSave }) => {
    const [loading, setLoading] = useState(false);
    const { user, setFeedback } = useAuth();

    // Only show button if user has calendarAdmin = true
    if (!user || !user.calendarAdmin) {
        return null;
    }

    const handleSpecialToggle = async () => {
        if (!event || !event.id) {
            console.error("Event or event ID is missing");
            return;
        }

        setLoading(true);

        try {
            const token = window.localStorage.getItem("authToken");
            const newSpecialValue = !event.special;

            const response = await fetch(`${BACKEND_HOST}/events/${event.documentId}/markSpecial`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { "Authorization": `Bearer ${token}` })
                },
                body: JSON.stringify({
                    data: {
                        special: newSpecialValue
                    }
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to update event: ${response.statusText}`);
            }

            setFeedback({ message: newSpecialValue ? "Marked as special" : "Removed special mark", color: "success" });

            // Refresh events to get updated data
            onSave && onSave();

        } catch (error) {
            console.error("Error updating special status:", error);
            setFeedback({ message: "Failed to update special status", color: "error" });
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Button disabled size="small">
                <CircularProgress size={16} />
            </Button>
        );
    }

    return (
        <Button
            size="small"
            onClick={handleSpecialToggle}
            startIcon={event.special ? <StarIcon /> : <StarBorderIcon />}
            variant={event.special ? "contained" : "outlined"}
            color="primary"
        >
            Special
        </Button>
    );
};

export default SpecialButton;